/** @jsx jsx */
import { css, jsx } from '@emotion/core';

import { Button, Spacer, Link } from '@zapier/design-system';
import { SizeType } from '@zapier/product-get-help/src/types';
import { urlWithNext } from '@zapier/url-utils';

import Surface from '@zapier/product-get-help/src/components/shared/Surface';

type LoginBlockProps = {
  /** Function to call when user clicks 'Log in'. Just for tracking as the component will deal with actually logging in. */
  onClickLogIn: () => void;
  /** Function to call when user clicks 'Sign Up'. Just for tracking as the component will deal with actually signing up. */
  onClickSignUp: () => void;
  /** Function to call when user clicks 'Continue without logging in'. Just for tracking as the component will deal with actually skipping logging in. */
  onClickContinue: () => void;
  /** Size to display. */
  size?: SizeType;
};

const gridCss = css`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 0.3fr 0.3fr 1fr;
`;

const gridChildCss = css`
  justify-self: end;
  align-self: center;
`;

/**
 * Renders the login block.
 */
const LoginBlock = ({
  onClickLogIn,
  onClickSignUp,
  onClickContinue,
  size = 'large',
}: LoginBlockProps) => {
  const next = `${window.location.pathname}${window.location.search}`;

  return (
    <Surface
      backgroundColor="neutral100"
      size={size}
      title="Log in for better support!"
    >
      <p>
        Logging in with your Zapier account will give our support system access
        to specific Zaps and Developer integrations so we can help you faster.
      </p>
      <Spacer height={13} />
      <div css={gridCss}>
        <Button
          color="primary"
          href={urlWithNext('/app/login', next)}
          onClick={onClickLogIn}
          size="small"
        >
          Log in
        </Button>{' '}
        <Button
          color="secondary"
          href={urlWithNext('/sign-up/', next)}
          onClick={onClickSignUp}
          size="small"
        >
          Sign Up
        </Button>
        <div css={gridChildCss}>
          <Link onClick={onClickContinue} weight="normal">
            Continue without logging in
          </Link>
        </div>
      </div>
    </Surface>
  );
};

export default LoginBlock;
